import Layout from './layout/reducer';
import Login from './login/reducer';

export default { Layout, Login };